import React from 'react'
import { Container, Row, Col, Image, Card, Breadcrumb } from "react-bootstrap";
import { Link } from "react-router";
import QaTestingCarousel from './QaTestingCarousel';
import TechBlock from '../TechBlock';
import QaTestingFaq from './QaTestingFaq';
import ServiceSlider from './ServiceSlider';

import gradient from "../../Assets/banner-blue-pill.png";

export default function QaTestingServices() {
    return (
        <>
            <section className='bg-theme section-hero'>
                <Container className="header-section pb-5 pt-2">
                    <Breadcrumb className="custom-breadcrumb">
                        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                        <span className="separator">›</span>
                        <Breadcrumb.Item href="/service">
                            Services
                        </Breadcrumb.Item>
                        <span className="separator">›</span>
                        <Breadcrumb.Item active>Quality Assurance & Testing Services</Breadcrumb.Item>
                    </Breadcrumb>
                    <Row className='mb-4 pt-5'>
                        <Col md={11}>
                            <h2 className="heading-style-h2 pb-3 text-white"><span className="text-gradient-1">Quality Assurance & Testing </span> Services</h2>
                            <h5 className='heading-style-h5 pb-5 text-white'>Testing that helps software stay stable, reliable, and ready for real use.</h5>
                        </Col>
                    </Row>
                    <div className="pills-wrap">

                        <div className="hero-pill-right-wrap animation_slide-up-delay-2">
                            <Image src={gradient} />
                        </div>
                    </div>
                </Container >
            </section >
            <section className='padding-section-large bg-gradient-1'>
                <Container>
                    <Row>
                        <Col md={9}>
                            <h2 className="heading-style-h2 pb-3">The Role of <span className="text-gradient-1"> Testing in Your Software</span></h2>
                        </Col>
                        <h5 className='heading-style-h5 mb-5'>Quality assurance goes beyond finding bugs before release. It helps make sure your software behaves as expected in real usage.</h5>
                        <h5 className='heading-style-h5 mb-5'>Testing supports product quality, release confidence, and long-term system stability. It helps teams catch issues early, reduce disruption, and improve how software performs over time.</h5>
                        <h5 className='heading-style-h5'>QA is treated as an ongoing part of delivery, not just something done before release. The focus is on reducing avoidable issues and helping releases move forward with fewer surprises.</h5>
                    </Row>
                </Container>
            </section>
            <Container className="padding-section-large">
                <Row className='mb-4'>
                    <Col md={9}>
                        <h2 className="heading-style-h2 pb-3">What We Offer in <span className="text-gradient-1">Quality Assurance & Testing</span></h2>
                        <h5 className='heading-style-h5 pb-5'>A mix of testing approaches used to validate functionality, performance, and overall software quality.</h5>
                    </Col>
                </Row>
                <Row className="align-items-center mb-5 serviceCard bg-gradient-1 p-4">
                    {/* LEFT CONTENT */}
                    <Col md={12}>

                        <div className="banner-content">
                            <h4 className='heading-style-h4'>Manual Testing</h4>
                            <p className="desc">We test workflows, features, and user journeys in detail to catch issues that affect real usage.</p>

                            {/* LINKS */}
                            <div className="banner-links text-gradient-1 mb-4">
                                <span>Functional testing</span>
                                <span>Regression testing</span>
                                <span>User-flow validation</span>
                            </div>
                        </div>
                    </Col>
                </Row>

                <Row className="align-items-center mb-5 serviceCard  p-4">
                    {/* LEFT CONTENT */}
                    <Col md={12}>
                        <div className="banner-content">
                            <h4 className='heading-style-h4'>Automated Testing</h4>
                            <p className="desc">Automation helps speed up validation and keep testing consistent across repeated cycles.</p>

                            {/* LINKS */}
                            <div className="banner-links text-gradient-1 mb-4">
                                <span>Test automation setup</span>
                                <span>Reusable test coverage</span>
                                <span>Faster validation during releases</span>
                            </div>
                        </div>
                    </Col>
                </Row>

                <Row className="align-items-center mb-5 serviceCard  p-4">
                    {/* LEFT CONTENT */}
                    <Col md={12}>
                        <div className="banner-content">
                            <h4 className='heading-style-h4'>Performance and Load Testing</h4>
                            <p className="desc">We test how applications behave under pressure, so issues can be identified before they affect users.</p>

                            {/* LINKS */}
                            <div className="banner-links text-gradient-1 mb-4">
                                <span>Load testing</span>
                                <span>Performance validation</span>
                                <span>Bottleneck identification</span>
                            </div>
                        </div>
                    </Col>
                </Row>

                <Row className="align-items-center mb-5 serviceCard  p-4">
                    {/* LEFT CONTENT */}
                    <Col md={12}>
                        <div className="banner-content">
                            <h4 className='heading-style-h4'>Continuous Quality Checks</h4>
                            <p className="desc">Quality checks continue throughout delivery, not just before launching.</p>

                            {/* LINKS */}
                            <div className="banner-links text-gradient-1 mb-4">
                                <span>Ongoing validation during development</span>
                                <span>Early issue detection</span>
                                <span>Better release readiness</span>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
            <section className='bg-blue text-white py-5 blue-logo-bg'>
                <Container>
                    <Row>
                        {/* Left Text */}
                        <Col md={10}>
                            <h2 className='heading-style-h2 pb-3'>Want to Be Sure Your Software Holds Up?</h2>
                            <p>We’ll help you understand where issues might exist and how to improve overall stability before release.</p>
                        </Col>

                        {/* Right Button */}
                        <Col md={2} className="text-md-end mt-3 mt-md-0">
                            <Link to="/contact" className='btn btn-outline-light ls-10 rounded-pill text-uppercase'>Get QA Support</Link>
                        </Col>

                    </Row>
                </Container>
            </section>
            <QaTestingCarousel />
            <section className='padding-section-large bg-gradient-1'>
                <Container>
                    <Row className=''>
                        <Col md={10}>
                            <h2 className="heading-style-h2 pb-3">What QA Means for <span className="text-gradient-1">Your Business</span></h2>
                            <h5 className='heading-style-h5 pb-5'>Clear outcomes that improve software quality, reduce avoidable issues, and make releases easier to trust.</h5>
                        </Col>
                    </Row>
                    <Row className="d-flex align-items-stretch stagger-wrapper">
                        <div className="stagger-grid">
                            {/* Card 1 */}
                            <div className="card-box primary-border light-bg logo-bg">
                                <h5 className='heading-style-h5 mb-4 fw-bold'>Fewer issues reaching end users</h5>
                                <p>Catch defects early before they affect real usage and customer experience.</p>
                            </div>

                            {/* Card 2 */}
                            <div className="card-box card-moveBottom">
                                <h5 className='heading-style-h5 mb-4 fw-bold'>More confidence before every release</h5>
                                <p>Move forward with better visibility into what has been tested and what is ready to ship.</p>
                            </div>

                            {/* Card 3 */}
                            <div className="card-box card-2">
                                <h5 className='heading-style-h5 mb-4 fw-bold'>Better product stability over time</h5>
                                <p>Reduce regressions and keep software behaviour more consistent as features evolve.</p>
                            </div>

                            {/* Card 4 */}
                            <div className="card-box card-moveBottom">
                                <h5 className='heading-style-h5 mb-4 fw-bold'>Faster identification of issue</h5>
                                <p>Spot problems earlier and resolve them with less disruption to the release cycle.</p>
                            </div>

                            {/* Card 5 */}
                            <div className="card-box card-4">
                                <h5 className='heading-style-h5 mb-4 fw-bold'>Better quality across key workflows</h5>
                                <p>Validate critical user journeys, integrations, and edge cases that often get missed.</p>
                            </div>
                        </div>
                    </Row>
                </Container>
            </section>
            <TechBlock />
            <ServiceSlider />
            <section className='bg-blue text-white py-5 blue-logo-bg'>
                <Container>
                    <Row>
                        {/* Left Text */}
                        <Col md={9}>
                            <h2 className='heading-style-h2 pb-3'>Let’s Make Quality Easier to Trust</h2>
                            <p>We help teams improve testing, reduce avoidable issues, and move releases forward with better clarity.</p>
                        </Col>

                        {/* Right Button */}
                        <Col md={3} className="text-md-end mt-3 mt-md-0">
                            <Link to="/contact" className='btn btn-outline-light ls-10 rounded-pill text-uppercase'>Strengthen Your Testing with Parabola</Link>
                        </Col>
                    </Row>
                </Container>
            </section>
            <QaTestingFaq />
        </>
    )
}
